import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import cartUtils from '../../utils/cart.utils';
import alertUtils, { SWAL } from '../../utils/alert.util';

const AddToCartButton = ({ productId }) => {
    const [quantity, setQuantity] = useState(1);
    const onQuantityChange = (s) => {
        let { value } = s.target;
        if (value <= 0) {
            value = 1;
        }
        setQuantity(value);
    };
    const addToCart = () => {
        try {
            let listItem = [];
            const cartStorage = cartUtils.get();
            if (!cartStorage) {
                cartUtils.set([]);
            } else {
                listItem = JSON.parse(cartStorage);
            }
            if (listItem.length == 0) {
                listItem = [
                    {
                        id: productId,
                        quantity: quantity,
                    },
                ];
            } else {
                const objCheck = listItem.find((o) => o.id == productId);
                if (!objCheck) {
                    listItem = [
                        {
                            id: productId,
                            quantity: quantity,
                        },
                        ...listItem,
                    ];
                } else {
                    listItem = listItem.map((o) => {
                        if (o.id == productId) {
                            o.quantity = +o.quantity + +quantity;
                        }
                        return o;
                    });
                }
            }

            cartUtils.set(listItem);

            notificationUtils.success('Thêm vào giỏ hàng thành công');
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <>
            <div className="box space-30">
                <div className="row">
                    <div className="col-md-5">
                        <div className="title">
                            <h3>Số lượng</h3>
                        </div>

                        <input
                            value={quantity}
                            data-step="1"
                            title="Qty"
                            min="1"
                            size="4"
                            type="number"
                            onChange={onQuantityChange}
                        />
                    </div>
                </div>
            </div>

            <div className="action">
                <a
                    className="link-v1 add-cart bg-brand"
                    title="Thêm vào giỏ hàng"
                    onClick={addToCart}
                >
                    <span>Thêm vào giỏ hàng</span>
                </a>
                <a className="link-v1 wish" title="Yêu thích" href="#">
                    <i className="icon icon-heart"></i>
                </a>
            </div>
        </>
    );
};

AddToCartButton.propTypes = {};

export default AddToCartButton;

document
    .querySelectorAll('react-add-to-cart-button')
    .forEach((domContainer) => {
        const root = createRoot(domContainer);
        const productId = domContainer.dataset.productId;
        root.render(<AddToCartButton productId={productId} />);
    });
